<template>
  <div class="flex flex-col leading-normal tracking-normal bg-gray-100" id="main-body">
    <LayoutNavbar />

    <div class="w-full flex flex-col sm:flex-row flex-wrap sm:flex-nowrap py-4 flex-grow">
      <!-- fixed-width -->
      <div class="w-fixed pr-5 flex-shrink flex-grow-0 px-4">
        <div class="sticky top-0 pl-4 pt-1 h-full">
          <!-- nav goes here -->
          <LayoutClinicianSidebar />
        </div>
      </div>
      <main role="main" class="w-full flex-grow pt-1 px-3 min-h-screen-75 h-full">
        <NoticeBarComponent />

        <!-- fluid-width: main content goes here -->
        <RouterView />
      </main>
    </div>
    <footer class="bg-black mt-auto text-white">
      <LayoutFooter />
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useSidebarStore } from '../stores/sidebar' // adjust the path to your store
import { useMessagesStore } from '@/stores/messages'

import { useUserStore } from '@/stores/user'

import LayoutClinicianSidebar from '@/components/LayoutClinicianSidebar.vue'
import LayoutNavbar from '@/components/LayoutNavbar.vue'
import LayoutFooter from '@/components/LayoutFooter.vue'
import NoticeBarComponent from '@/components/NoticeBarComponent.vue'

export default defineComponent({
  name: 'DashboardLayout',
  components: {
    NoticeBarComponent,
    LayoutClinicianSidebar,
    LayoutNavbar,
    LayoutFooter
  },
  setup() {
    const store = useSidebarStore()
    const sideBarOpen = computed(() => store.sidebar)
    const messagesStore = useMessagesStore()

    const userStore = useUserStore()

    onMounted(async () => {
      try {
        if (await userStore.IsClinician()) {
          messagesStore.getClinicianMessagesPollingGlobal((newMessage) => {
            // console.log('New message received:', newMessage)
            messagesStore.updateUnreadMessages()
          })

        }

        // console.log('Clinician messages:', messagesStore.clinicianMessages)
        // console.log('unread messages', unreadMessages.value)
      } catch (error) {
        console.error('Error setting up messages on mount:', error)
      }
    })

    return {
      sideBarOpen
    }
  }
})
</script>
